import React from 'react';
import Container from './Container.js';
const Card = ({
  headline,
  children = null,
  noBorder = false
}) => /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("section", {
  className: `ebds-card ${noBorder ? 'ebds-card--no-border' : null}`
}, /*#__PURE__*/React.createElement("div", {
  className: "ebds-card__content"
}, /*#__PURE__*/React.isValidElement(headline) ? headline : /*#__PURE__*/React.createElement("h2", null, headline), /*#__PURE__*/React.createElement("div", {
  className: "ebds-card__content--no-margin-bottom"
}, children))));
export default Card;